import React from "react";

const RefundPolicyPage = () => {
  return (
    <div style={{ marginBottom: 40 }} className="container">
      <div className="main">
        <div className="title">Refund Policy</div> Last updated: 04/12/2023{" "}
        <n />
        At Jammable, we strive to provide our customers with the best possible
        experience while using our services. However, we understand that there
        may be situations where you might want to request a refund. This Refund
        Policy outlines the circumstances under which we provide refunds and the
        process for requesting a refund.
        <div className="subtitle">1. Eligibility for Refund</div> Jammable
        offers refunds in the following cases: - If you have purchased credits
        but have not used any of them. - If you have bought a subscription but
        have not created any conversions or used any of the features. In these
        cases, you are eligible for a refund, provided that you meet the
        conditions outlined in this policy. Refunds will not be provided in any
        other situations.
        <div className="subtitle">2. Refund Period</div> Refunds must be
        requested within 30 days of the purchase date. No refund requests will
        be entertained after the 30-day period has passed.
        <div className="subtitle"> 3. Refund Process</div> To request a refund,
        please follow these steps: - Contact our support team at
        support@jammable.com, providing your purchase details, including your
        order number, date of purchase, and the email address associated with
        your account. - Include a brief explanation of the reason for your
        refund request. - Our support team will review your request and confirm
        whether you are eligible for a refund based on the criteria outlined in
        this policy. Please note that refund requests may take up to 14 business
        days to be processed. Once your refund has been approved, it will be
        processed, and the funds will be returned to the original payment method
        used for the purchase. Refunds may take additional time to appear on
        your account, depending on your financial institution&apos;s policies.
        <div className="subtitle">4. Exclusions </div>Refunds will not be
        granted if: - You have used any purchased credits or have created AI
        cover music with your subscription. - Your account has been terminated
        or suspended due to violations of our Terms and Conditions or any
        applicable laws and regulations.{" "}
        <div className="subtitle">5. Changes to the Refund Policy</div> We
        reserve the right to modify or update this Refund Policy at our sole
        discretion. Any changes to this policy will be posted on our website,
        and we will indicate the date of the last update at the beginning of the
        policy. It is your responsibility to periodically review this policy to
        stay informed about any changes.{" "}
        <div className="subtitle"> 6. Contact Information</div> If you have any
        questions about this Refund Policy or wish to request a refund, please
        contact us:
        <n /> By email: support@jammable.com
      </div>
    </div>
  );
};

export default RefundPolicyPage;
